import { Method } from 'axios';

export type ApiMethod = Method | 'del' | undefined;

export const handleNativeHttpRequestFetcher = (
  url: string,
  method: ApiMethod,
  headers: any = {},
  options: any = {},
) =>
  fetch(url, {
    method,
    headers: headers || {
      'Content-Type': 'application/json',
    },
    ...options,
  }).then((res) => res.json());
